<template>
	<div :class="getTemplateClass()">
		<component 
			:is="componentView" 
			:item="item" 
			:section="section" 
			:is-popup="section.is_popup"
			:get-full-descr="getFullDescr"
			:button-order-text="buttonOrderText"
			class="flex-1"
		/>
	</div>
</template>

<script>

import templateProductDefault from './templates/TemplateProductDefault';
import templateProductAccor from './templates/TemplateProductAccor';
import templateProductMarriot from './templates/TemplateProductMarriot';


export default {
	name: 'app_product',
	props: [
		'item', 
		'section', 
		'parentSection',
		'templateView',
	],
 
	components: {templateProductAccor, templateProductDefault, templateProductMarriot},

	data(){
		return {
			readMoreActivated: false
		}
	},

	computed: {
		componentView: function() {
			if (this.$root.hotelCode == 'marriottpolyana' || this.$root.hotelCode == 'marriottimperialplaza' || this.$root.hotelCode === 'marriottroomservice' || this.$root.hotelCode == 'marriott-krasnodar' || this.$root.hotelCode == 'marins-nsk' || this.$root.hotelCode == 'marins-astrakhan' || this.$root.hotelCode == 'marins-nn' || this.$root.hotelCode == 'yaltaintourist' || this.$root.hotelCode === 'marins-ek' || this.$root.hotelCode === 'marins-rostov' || this.$root.hotelCode === 'marins-moscow' || this.$root.hotelCode === 'tropikana')
				return templateProductMarriot;
			if (this.$root.template == 'accor')
				return templateProductAccor;
			else
				return templateProductDefault;
		},

		getShortDescr() {
			if (this.item.descr === 'null'  || this.item.descr === null) return '';
			
			let descr = this.item.descr[this.$root.currentLanguage + '_short'];

			return (descr !== undefined && this.$root.stripTags(descr).length > 0) ? descr : '';
		},

		getFullDescr() {
			
			if (this.item.descr === 'null'  || this.item.descr === null) return '';

            let descr = this.item.descr[this.$root.currentLanguage];

            return (descr !== undefined && this.$root.stripTags(descr).length > 0) ? descr : '';
		},

		buttonOrderText() {
			let btnOrdTextProduct = this.$root.getLangText(this.item.button_order_text);
			let btnOrdTextSection = this.$root.getLangText(this.section.button_order_text);
			let btnOrdTextParentSection = this.$root.getLangText(this.parentSection.button_order_text);
			
			if (btnOrdTextProduct)
				return btnOrdTextProduct;

			if (btnOrdTextSection) 
				return btnOrdTextSection;

			if (btnOrdTextParentSection)
				return btnOrdTextParentSection	

			return this.$root.getKeyWord('send_to_cart');
		},

		displayOrderButton() {
                    return !this.section.hide_order_button;
		}
	},

	methods: {
		activateReadMore() {
			this.readMoreActivated = true;
		},

		addFrom(item) {
			return item.is_price_from ? this.$root.getKeyWord('from') + ' ' : ''
		},

		getTemplateClass() {
			if (this.templateView == 'grid' || this.templateView == 'grid_np') 
				return 'w-1/2 p-1 flex-col flex'
			return '';
		}
	}
}
</script>

<style>
	.read-more{
		color: var(--main-color);
		text-decoration: underline;
	}
	.free-delivery-text {
		background: -webkit-gradient(linear, left top, right top, from(#0072ff), to(#00d4ff));
		background: linear-gradient(90deg, #0072ff 0%, #00d4ff 100%);
		letter-spacing: 0;
	}
	.text-big {
		font-size: 20px !important;
		font-weight: 400;
	}

	.color-katowice {
		background: #a790c4;
	}

	.color-london {
		background: #D83715;
	}

	.color-cambridge {
		background: #1e22aa;
	}
</style>